import {Form} from "../models/Form";

import {BasicStep} from "../models/steps/BasicStep";
import {ButtonStep} from "../models/steps/ButtonStep";
import {KeyboardStep} from "../models/steps/KeyboardStep";

import store from '../store'

import ThanksRedirectStep from "../components/form/steps/library/nl/thanks_redirect/ThanksRedirectStep";
import HomeStep from "../components/form/steps/library/nl/mobile_home/HomeStep";
import EmailStep from "../components/form/steps/library/nl/email/EmailStep";
import AddressStep from "../components/form/steps/library/nl/address/AddressStep";
import PhoneStep from "../components/form/steps/library/nl/phone/PhoneStep";
import IbanStep from "../components/form/steps/library/nl/iban_optim_2023/IbanStep";
import PaymentOptinStep from "../components/form/steps/library/nl/payment_optin/PaymentOptinStep";
import SmsThanksStep from "../components/form/steps/library/nl/sms_thanks/SmsThanksStep";

import MobileFlux from "../views/nl_new_branding/MobileView";
import HomeView from "../views/nl_opCookies_white_v2_2025/HomeView.vue";
import NameGenderStep from "../components/form/steps/library/nl/name-gender/NameStep.vue";


let sms_service_status = window.sms_service_status==1 ? 'sms' : 'redirect_thanks';


export default new Form(MobileFlux)
    .firstStep('home')
    .apiEndpoint('/prospect')
    .addSteps({
        home: new BasicStep(HomeStep).nextStep('name_gender').parentComponent(HomeView),
        name_gender: new BasicStep(NameGenderStep).nextStep('email')
            .beforeMount(() => {
                store.set('general_data/is_dirty', true)
            })
            .button('Bevestigen'),
        email: new BasicStep(EmailStep).nextStep('address')
            .button('Bevestigen')
            .addFieldsToSend(['gender', 'lastname', 'firstname', 'email', 'optin_terms_conditions', 'optin_privacy']),
        address: new BasicStep(AddressStep).nextStep('iban')
            .addFieldsToSend(['street', 'street_number', 'street_box_number', 'zip_code', 'city'])
            .button('Bevestigen'),
        iban: new KeyboardStep(IbanStep).nextStep('payment_optin').button('Bevestigen')
            .guard(['iban', 'optin_iban', 'phone', 'general_data/is_test'])
            .progressBarText(true)
            .beforeMount(() => {
                if (!store.get('form_data/iban')) {
                    store.set('form_data/iban', 'BE')
                }
            })
            .addFieldsToSend(['iban']),
        payment_optin: new ButtonStep(PaymentOptinStep).nextStep('phone')
            .addFieldsToSend(['optin_iban']),
        phone: new BasicStep(PhoneStep).nextStep(sms_service_status).disableBackButton()
            .addFieldsToSend(['phone'])
            .button('Stuur me een activatielink')
            .beforeMount(() => {
                if (!store.get('form_data/phone')) {
                    store.set('form_data/phone', '+32')
                }
            })
            .beforeLeave(() => {
                let match_token = store.get('general_data/match_token')
                let phone = store.get('form_data/phone')
                let form_token = store.get('general_data/form_token')
                let lang = store.get('general_data/lang')
                let country = store.get('general_data/country')
                let is_test = store.get('general_data/is_test')

                store.set('func_data/match_token', match_token);
                store.set('func_data/phone', phone);
                store.set('func_data/form_token', form_token);
                store.set('func_data/lang', lang);
                store.set('func_data/country', country);
                store.set('func_data/is_test', is_test);
                return axios.post('/send_sms_thanks',
                    {
                        phone,
                        match_token,
                        form_token,
                        lang,
                        country,
                        is_test
                    })
            }),
        redirect_thanks: new BasicStep(ThanksRedirectStep).last().disableBackButton(),
        sms: new BasicStep(SmsThanksStep).last().disableBackButton(),

    });
